import useApi from '@/composables/useApi.ts';

/**
 * Reports a document download to the analytics module.
 *
 * Needed because the download buttons are plain `<a download>` links to the asset's secure URL,
 * which nginx serves straight from disk - the server never sees those requests. Only the bulk
 * download in DownloadFilesButton goes through a controller and records itself.
 *
 * A download link does not navigate the page away, so an ordinary request has time to finish.
 */
export default function useDownloads() {
    const useFetch = useApi();

    function trackDownload(uid?: string): void {
        if (!uid) {
            return;
        }

        useFetch('track-download').post({ uid });
    }

    return { trackDownload };
}
